import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from './Icon';
import './Accordion.css';

/**
 * Stacked accordion. Each item is a full-width bar; the open bar
 * reveals its panel underneath. Sharp corners, token colors.
 */
export function Accordion({
  children,
  className = '',
  'data-testid': dataTestId = 'onyx-accordion',
}) {
  return (
    <div
      className={['onyx-accordion', className].filter(Boolean).join(' ')}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
}

export function AccordionItem({
  title,
  children,
  defaultOpen = false,
  className = '',
}) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();
  const headerId = `${panelId}-header`;

  return (
    <div
      className={[
        'onyx-accordion__item',
        open ? 'onyx-accordion__item--open' : '',
        className,
      ].filter(Boolean).join(' ')}
      data-open={open ? 'true' : 'false'}
    >
      <button
        type="button"
        className="onyx-accordion__trigger"
        aria-expanded={open}
        aria-controls={panelId}
        id={headerId}
        onClick={() => setOpen((current) => !current)}
      >
        <span className="onyx-accordion__title">{title}</span>
        <Icon
          name={open ? 'expandLess' : 'expand'}
          className="onyx-accordion__chevron"
          aria-hidden
        />
      </button>
      {open ? (
        <div
          id={panelId}
          role="region"
          aria-labelledby={headerId}
          className="onyx-accordion__panel"
        >
          {children}
        </div>
      ) : null}
    </div>
  );
}

Accordion.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  'data-testid': PropTypes.string,
};

AccordionItem.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
  className: PropTypes.string,
};
